// -----------------------------------------------------------------------------
// <copyright file="loader.component.ts" company="ecoInsight, Inc.">
// Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------

import { ChangeDetectionStrategy, Component, input, inject } from '@angular/core';

import { LoaderService } from './loader.service';

@Component({
  selector: 'vs-loader',
  templateUrl: './loader.component.html',
  standalone: false,
})
export class LoaderComponent {
  loading = input<boolean>(false);
  loader = inject(LoaderService);
}
